import React from 'react';
import { Link, NavLink } from 'react-router-dom';

const AdminLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex bg-gray-100 dark:bg-gray-900">
      <aside className="w-64 bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 flex flex-col">
        <div className="h-16 flex items-center px-4 border-b border-gray-200 dark:border-gray-800">
          <Link to="/" className="flex items-center space-x-2">
            <img
              src="/logo_black.webp"
              alt="OKIO"
              className="h-6 w-auto dark:hidden"
            />
            <img
              src="/logo_white.webp"
              alt="OKIO"
              className="h-6 w-auto hidden dark:block"
            />
          </Link>
        </div>
        <nav className="flex-1 p-4 space-y-1 text-sm">
          <NavLink
            to="/admin"
            end
            className={({ isActive }) =>
              [
                'block px-3 py-2 rounded-md transition-colors',
                isActive
                  ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 font-medium'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800',
              ].join(' ')
            }
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/admin/users"
            className={({ isActive }) =>
              [
                'block px-3 py-2 rounded-md transition-colors',
                isActive
                  ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300 font-medium'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800',
              ].join(' ')
            }
          >
            Users
          </NavLink>
        </nav>
        <div className="px-4 py-3 border-t border-gray-200 text-xs text-gray-400">
          Admin tools
        </div>
      </aside>
      <main className="flex-1 p-6 overflow-auto">
        <div className="max-w-6xl mx-auto">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;


